import { Faq, MINIFAQ_SOURCES } from '@/containers/Faq';
import s from './index.module.scss';

export const StreaksFaq = () => {
  return (
    <div className={s.wrapper}>
      <Faq source={MINIFAQ_SOURCES.investmentStreak} />
    </div>
  );
};
